module.exports = __webpack_public_path__ + "img/51.2ff03cf0.jpg";